import { render, staticRenderFns } from "./pubsale.vue?vue&type=template&id=3a6dcf04&scoped=true&"
import script from "./pubsale.vue?vue&type=script&lang=js&"
export * from "./pubsale.vue?vue&type=script&lang=js&"
import style0 from "./pubsale.vue?vue&type=style&index=0&id=3a6dcf04&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6dcf04",
  null
  
)

export default component.exports